import { DATE_RANGE_TOO_LONG, ERROR_TYPE } from '@/utils/dashboard';
import WarningIcon from '@svgIcons/widget_warning.svg';
import ErrorIcon from '@svgIcons/widget_error.svg';

const changePluralToSingular = R.compose(
    R.when(R.endsWith('s'), R.slice(0, -1)),
    R.defaultTo('')
);

export const ErrorHeader = {
    name: 'ErrorHeader',
    props: {
        errorCode: {
            type: String,
        },
        type: {
            type: String,
        },
        lastErrorSource: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    render() {
        return (
            <div class="widget-error-panel__item__container">
                <p class="widget-error-panel__icon_wrapper">
                    {this.type === ERROR_TYPE.WARNING && <WarningIcon />}
                    {this.type === ERROR_TYPE.ERROR && <ErrorIcon />}
                </p>
                <div class="widget-error-panel__item__text_wrapper">
                    <p
                        class="widget-error-panel__item__title"
                        domPropsInnerHTML={this.$t(
                            `WIDGET.error_panel.error.${this.errorCode}`,
                            this.errorCode === DATE_RANGE_TOO_LONG
                                ? (() => {
                                      const duration = R.pathOr(
                                          {},
                                          [
                                              'properties',
                                              'meta',
                                              'durations',
                                              0,
                                          ],
                                          this.lastErrorSource
                                      );

                                      const { unit, value } = duration;

                                      const singularUnit =
                                          changePluralToSingular(unit);

                                      return {
                                          unit: this.translateOr(
                                              `COMMON.date_unit_${singularUnit}`,
                                              singularUnit
                                          ),
                                          numbers: value,
                                      };
                                  })()
                                : {}
                        )}
                    ></p>
                </div>
            </div>
        );
    },
};
